let apiUri = process.env.REACT_APP_API_URI;
let loginAV2API = process.env.REACT_APP_LOGIN_AV2_API_URL;
let apiUriAV2 = process.env.REACT_APP_LINK_AV2_URL;
// let apiUriUCA = process.env.REACT_APP_API_URI_UCA;
let callback = process.env.REACT_APP_CALLBACK;
let agendamientoExperto = process.env.REACT_APP_AGENDAMIENTO_EXPERTO;
let redUri = process.env.REACT_APP_RED_URL;
let LFGUrl = process.env.REACT_APP_LFG_URL;
let sapUri = process.env.REACT_APP_SAP_URL;
let denunciasUri = process.env.REACT_APP_DENUNCIAS_URL;
let devolucionesUri = process.env.REACT_APP_DEVOLUCIONES_URL;
let prestacionesUri = process.env.REACT_APP_PRESTACIONES_URL;
let estadisticasUri = process.env.REACT_APP_ESTADISTICAS_URL;
let certificadosUri = process.env.REACT_APP_CERTIFICADOS_URL;
let prevencionUri = process.env.REACT_APP_PREVENCION_URL;
let ds67Uri = process.env.REACT_APP_DS67_URL;
let capacitacionesUri = process.env.REACT_APP_CAPACITACIONES_URL;
let uriMail = process.env.REACT_APP_MAIL_URL;
let applicationid = process.env.REACT_APP_APPLICATION_ID;
let OcpApimSubscriptionKey = process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY;
let notificationHUB = process.env.REACT_APP_NOTIFICATION_HUB;
let urlLink = process.env.REACT_APP_LINK_URL;
let WebSocketUrl = process.env.REACT_APP_WEBSOCKET_URL;
// plan movilidad
let linkEncuestasMovilidad = process.env.REACT_APP_MOVILIDAD_ENCUESTAS_URL;
let baseUriApiMovilidad = process.env.REACT_APP_MOVILIDAD_API_URL;
let selUrl = process.env.REACT_APP_SEL_URL;
let autoevaluacionUri = process.env.REACT_APP_AUTOEVALUACION_URL;
let buscaBPCRM = process.env.REACT_APP_BUSCA_BP_CRM_URL;

let resultadoExamenesTrabajador = process.env.REACT_APP_EXAMENES_TRAB_URL;
let pagosPendientes = process.env.REACT_APP_PAGOS_PENDIENTES_URL;
let estadoPension = process.env.REACT_APP_ESTADO_PENDIENTE_INDEMINIZACIONES_URL;
let gestionarCapacitaciones = process.env.REACT_APP_GESTION_CURSOS_ELEARNING_URL;
let afiliateAchsUrl = process.env.REACT_APP_AFILIATE_ACHS_URL;
let rutAchs = process.env.REACT_APP_RUT_ACHS;
let idTrabajadorDependiente = process.env.REACT_APP_DEPENDENT_WORKER_ROL;
let idTrabajadorACHS = process.env.REACT_APP_ACHS_WORKER_ACHS;

const config = {
  gestionarCapacitaciones,
  agendamientoExperto,
  autoevaluacionUri,
  apiUri,
  loginAV2API,
  apiUriAV2,
  // apiUriUCA,
  callback,
  redUri,
  uriMail,
  LFGUrl,
  applicationid,
  OcpApimSubscriptionKey,
  sapUri,
  denunciasUri,
  devolucionesUri,
  prestacionesUri,
  estadisticasUri,
  certificadosUri,
  prevencionUri,
  ds67Uri,
  capacitacionesUri,
  notificationHUB,
  urlLink,
  WebSocketUrl,
  // plan movilidad
  linkEncuestasMovilidad,
  baseUriApiMovilidad,
  selUrl,
  buscaBPCRM,
  resultadoExamenesTrabajador,
  pagosPendientes,
  estadoPension,
  rutAchs,
  afiliateAchsUrl,
  idTrabajadorACHS,
  idTrabajadorDependiente,
  mundoAchsUrl: process.env.REACT_APP_MUNDO_ACHS_URL,
  mundoAchsEmpresaUrl: process.env.REACT_APP_MUNDO_ACHS_EMPRESA_URL,
};

export default config;
